export default function initFade() {
  const fadeContents = document.querySelectorAll('.fade-up');
  if (!fadeContents.length === 0) return;

  const activeClass = 'active';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(activeClass);
        }
      });
    },
    {
      threshold: 0.2,
    }
  );

  fadeContents.forEach((fadeContent) => observer.observe(fadeContent));
}
